<app-view-card>
    <red-top-toolbar>
        <span redTopToolbarTitle i18n="Card transaction|Main title for Card transaction View">Red flag card</span>
    </red-top-toolbar>
    <app-view-card-infobar class="view-card-infobar">
        <app-red-flag-shut-down-banner></app-red-flag-shut-down-banner>
    </app-view-card-infobar>
    <router-outlet></router-outlet>
</app-view-card>
